import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ZoomRangeSettings } from '@/components/common/ZoomRangeSettings';
import {
  MAP_SETUP_ZOOM_MAX,
  MAP_SETUP_ZOOM_MIN,
  MAP_SETUP_ZOOM_STEP,
} from '@/constants';
import { ConfigSectionLabel } from './ConfigSectionLabel';

interface ZoomSlidersProps {
  startZoom: number;
  minZoom: number;
  maxZoom: number;
  onStartZoomChange: (value: number) => void;
  onMinZoomChange: (value: number) => void;
  onMaxZoomChange: (value: number) => void;
}

/**
 * Map-configurator wrapper around the shared `ZoomRangeSettings` sliders.
 * Supplies the map-setup bounds and section heading; clamping stays in
 * `useMapSetupForm`.
 */
export const ZoomSliders = memo(function ZoomSliders({
  startZoom,
  minZoom,
  maxZoom,
  onStartZoomChange,
  onMinZoomChange,
  onMaxZoomChange,
}: ZoomSlidersProps) {
  const { t } = useTranslation();

  return (
    <ZoomRangeSettings
      header={
        <ConfigSectionLabel>{t('mapSetup.zoom.title')}</ConfigSectionLabel>
      }
      startZoom={startZoom}
      minZoom={minZoom}
      maxZoom={maxZoom}
      onStartZoomChange={onStartZoomChange}
      onMinZoomChange={onMinZoomChange}
      onMaxZoomChange={onMaxZoomChange}
      min={MAP_SETUP_ZOOM_MIN}
      max={MAP_SETUP_ZOOM_MAX}
      step={MAP_SETUP_ZOOM_STEP}
    />
  );
});
